export enum AiSource {
  AiGenerated = 'ai_generated',
  AiModified = 'ai_modified',
  AiUpdated = 'ai_updated',
}
